export const TOKEN_COOKIE_NAME = 'grafbase_token'
